import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { useEffect } from "react";
import {
  hasRolesForCompliance,
  useCanSeeFxBackedComplianceScreen,
  useCanSeeTmBackedComplianceScreen,
} from "./_compliance/-components/is-compliance-enabled";

export const Route = createFileRoute("/(app)/_main-layout/_compliance")({
  component: ComplianceRootLayoutRoute,
});

function ComplianceRootLayoutRoute() {
  const canSeeFxBackedComplianceScreen = useCanSeeFxBackedComplianceScreen();
  const canSeeTmBackedComplianceScreen = useCanSeeTmBackedComplianceScreen();
  const context = Route.useRouteContext();
  const location = useLocation();
  const navigate = useNavigate();

  const canAccessCompliance =
    (canSeeTmBackedComplianceScreen || canSeeFxBackedComplianceScreen) &&
    hasRolesForCompliance(context.authorities);

  useEffect(() => {
    if (!canAccessCompliance && location.pathname.startsWith("/compliance")) {
      navigate({ to: "/" });
    }
  }, [canAccessCompliance, location.pathname, navigate]);

  if (!canAccessCompliance) {
    return null;
  }

  return <Outlet />;
}
